<template>

  <!--  <q-list>-->
  <!--    <q-expansion-item v-model="expanded" icon="watch_later" header-class="text-bold" header-style="font-size: 20px"-->
  <!--                      label="Contract Length">-->
  <div class="q-pa-sm" :class="{'text-primary': !no_term_selected}">

    <q-inner-loading :showing="available_terms_loading">
      <q-spinner-gears size="50px" color="primary"/>
    </q-inner-loading>

    <div class="text-bold">Contract Length</div>
    <div class="text-bold">(select all that apply)</div>

    <q-checkbox v-model="no_term_selected" label="Show All" color="primary" class="text-blue-grey-8"
                :disable="no_term_selected"
                @click="clear_term_selection"></q-checkbox>

    <div v-for="term in available_terms" v-if="available_terms">
      <q-checkbox v-model="selected_terms" color="primary" :class="term.disabled ? 'text-blue-grey-4' : 'text-blue-grey-8'"
                  :val="term.value" :label="term.name"></q-checkbox>
    </div>
  </div>

  <!--    </q-expansion-item>-->
  <!--  </q-list>-->

</template>

<script>
import Terms from "src/composables/Terms";
import { ref } from "vue";

export default {
  name: "TermFilter",
  setup() {
    const expanded = ref(true);
    const { available_terms_loading, available_terms, selected_terms, no_term_selected, clear_term_selection } = Terms()

    return {
      expanded,
      available_terms_loading,
      available_terms,
      selected_terms,
      clear_term_selection,
      no_term_selected
    }
  }
}
</script>

<style scoped>

</style>
